<script setup>
defineProps({
  error: Object,
});

const { t } = useI18n();
const localePath = useLocalePath();

useSeoMeta({
  title: () => t("error_module.title"),
  description: () => t("error_module.description"),
});

const goHome = () => clearError({ redirect: localePath("/") });
</script>

<template>
  <Menu />
  <div
    class="mx-auto max-w-7xl flex flex-col items-center text-center p-6 lg:px-8 mt-10 mb-20 lg:mt-20 lg:mb-40"
  >
    <div class="text-[120px] lg:text-[220px] leading-none font-thin text-[#BDBDBD]">
      404
    </div>
    <div class="text-2xl lg:text-4xl font-semibold text-[#333333] mt-4">
      {{ $t("error_module.title") }}
    </div>
    <div class="text-[#4D4D4D] max-w-xl mt-6">
      {{ $t("error_module.description") }}
    </div>
    <div class="mt-10">
      <AnchorButton @click="goHome" :label="$t('error_module.back_home')" />
    </div>
  </div>
  <Footer />
</template>
